import React, { useState, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ReactReduxContext } from 'react-redux'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useInitOfSavingPath } from '../../hooks/useBackButton'

import ProfileInfo from '../../components/profile/profileInfo'
import ProfileEdit from '../../components/profile/profileEdit'
import AlbumPreview from '../../components/profile/materials/albumPreview'
import ContributionsPreview from '../../components/profile/materials/contributionsPreview'
import GuestbookPreview from '../../components/profile/materials/guestbookPreview'
import GiftsPreview from '../../components/profile/materials/giftsPreview'

import { Helmet } from 'react-helmet'

import { RootState } from '../../store/rootReducer'
import { AlbumType, PhotoType } from '../../store/commonTypes'
import { MemberState } from '../../store/member/memberTypings'

import { genders, pages } from '../../constants'
import { checkAuth, loadMember, loadMemberContributions, loadMemberProfile } from '../../utils/auth'
import './profile.sass'
import paths from '../../paths'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import { useHistory, useLocation } from 'react-router-dom'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { memberFetch } from '../../store/member/memberSlice'
import ForumBlock from '../../components/forumBlock/ForumBlock'
import { META } from '../../constants/meta'

const Member = () => {
    usePageLoaded()
    useInitOfSavingPath()

    const location = useLocation()
    const [t] = useTranslation()
    const history = useHistory()

    const {
        user,
        userPhotos,
        contributionsList,
        contributionsTotal,
        userGuestbook,
        virtualGifts,
        loggedIn,
        guestbookTotal,
        userForumPosts,
        userForumPostsTotal
    } = useSelector<RootState, MemberState>((state) => state.member)
    const { store } = useContext(ReactReduxContext)

    const [showEdit, setShowEdit] = useState(false)

    const publicAlbum: AlbumType = {
        id: 'public',
        title: 'Public album',
        list: userPhotos
    }

    useEffect(() => {
        if (!loggedIn)
            history.replace(
                createLocalizedPath(`/login_required?returnPath=${createLocalizedPath(paths.myProfile.path)}`)
            )
    }, [loggedIn])

    useEffect(() => {
        if (loggedIn && !contributionsTotal) loadMember(store)
    }, [loggedIn])
    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.member[getLangFromPath(location.pathname)].title}</title>
                <meta name="description" content={user && user.about ? user.about : 'Membre information'} />
            </Helmet>
            {showEdit ? (
                <ProfileEdit onClose={() => setShowEdit(false)} />
            ) : (
                <ProfileInfo user={user} self switchEdit={() => setShowEdit(true)} />
            )}
            {user && (
                <>
                    <AlbumPreview user={user} album={publicAlbum} self />
                    <ContributionsPreview
                        user={user}
                        contributions={contributionsList ? contributionsList.slice(0, 8) : []}
                        contributionsTotal={contributionsTotal}
                        self
                        direction={pages.member}
                    />
                    <GiftsPreview recipient={user.nick} gifts={virtualGifts} isOutgoing={false} />
                    {userForumPosts.length ? (
                        <ForumBlock forumPosts={userForumPosts} self={true} userForumPostsTotal={userForumPostsTotal} />
                    ) : (
                        <></>
                    )}
                    <GuestbookPreview
                        user={user}
                        guestbookItems={userGuestbook.slice(0, 20)}
                        self
                        guestbookTotal={guestbookTotal}
                    />
                </>
            )}
        </div>
    )
}

// @ts-ignore
Member.getInitialProps = async ({ req, store }) => {
    const {
        member: { loggedIn }
    } = store.getState()
    if (req) {
        await checkAuth(store)
        if (loggedIn) {
            // await loadMember(store)
            await store.dispatch(memberFetch({ full: 1 }))
            await loadMemberContributions(store)
        } else {
            return {
                redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.myProfile.path}`
            }
        }
    } else {
        if (loggedIn) {
            store.dispatch(memberFetch({ full: 1 }))
            await loadMemberContributions(store)
        }
    }
}

export default Member
